import { useDashboardStore } from '@/stores/dashboardStore';
import { useViewportReset } from '@/hooks/useViewportReset';
import Header from '@/components/layout/Header';
import Tabs from '@/components/layout/Tabs';
import Overview from '@/pages/Overview';
import DailyShipment from '@/pages/DailyShipment';
import Inventory from '@/pages/Inventory';
import Sanyi from '@/pages/Sanyi';
import VanSales from '@/pages/VanSales';
import Campus from '@/pages/Campus';
import TeamExecution from '@/pages/TeamExecution';
import CustomerRisk from '@/pages/CustomerRisk';
import Radar from '@/pages/Radar';
import DrillModal from '@/components/DrillModal';
import ChatWidget from '@/components/assistant/ChatWidget';

const PAGE_MAP: Record<string, React.FC> = {
  综合驾驶舱: Overview,
  每日出库: DailyShipment,
  进销存: Inventory,
  三一工程: Sanyi,
  车铺车销: VanSales,
  校园压仓: Campus,
  团队执行力: TeamExecution,
  客户综合评估: CustomerRisk,
  异常定位雷达: Radar,
};

export default function App() {
  const currentTab = useDashboardStore((s) => s.currentTab);
  const Page = PAGE_MAP[currentTab] || Overview;

  useViewportReset();

  return (
    <div className="app">
      <Header />
      <Tabs />
      <main>
        <Page />
      </main>
      <DrillModal />
      <ChatWidget />
    </div>
  );
}
